export default word => (word ? word.toUpperCase() : null)
